import fetch from 'src/http/fetch'

//  通告通知
export function notifications () {
  return fetch('notification/list', {})
}



// WEBPACK FOOTER //
// ./src/api/notificationApi.js